import { Component, EventEmitter, Input, Output, ViewChild, OnInit } from '@angular/core';
import { DashboardCard, DashboardFilter } from 'src/app/models/dashboard.model';
import * as moment from 'moment';
import { DaterangepickerDirective, LocaleConfig } from 'ngx-daterangepicker-material';
import { LocaleConfigDate, rangesDateDashboard } from 'src/app/constants/date-config.const';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BaseService } from 'src/app/services/base.service';
import { cardsPayment } from 'src/app/constants/dashboard.const';
import { PAYMENT_REVENUE } from 'src/app/constants/endpoint.const';

interface LocalSelectedDate {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

@Component({
  standalone: false,
  selector: 'app-payment-service',
  templateUrl: './payment-service.component.html',
  styleUrl: './payment-service.component.scss'
})
export class PaymentServiceComponent implements OnInit {
  @ViewChild(DaterangepickerDirective, { static: false })
  datePicker!: DaterangepickerDirective;
  loading: boolean = true;
  startDate: string = '';
  endDate: string = '';
  setlocale: LocaleConfig = LocaleConfigDate;
  keepCalendarOpeningWithRange: boolean;
  selected: LocalSelectedDate = {
    startDate: moment(),
    endDate: moment(),
  };
  // @ts-ignore
  ranges: any = rangesDateDashboard
  invalidDates: moment.Moment[] = [
    moment().add(2, 'days'),
    moment().add(3, 'days'),
    moment().add(5, 'days'),
    ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, 'day'));
  };

  @Input() filter: DashboardFilter = {
    start_date: moment().format('DD-MM-YYYY'),
    end_date: moment().format('DD-MM-YYYY'),
  };

  @Output() filterResult = new EventEmitter<DashboardFilter>();
  cardsPayment: DashboardCard[] = cardsPayment;

  constructor(
    public formatter: NgbDateParserFormatter,
    public baseService: BaseService,
    private message: NzMessageService,
  ) {
    this.keepCalendarOpeningWithRange = true;
  }

  ngOnInit(): void {
    this.selected = {
      startDate: moment(this.filter.start_date, 'DD-MM-YYYY'),
      endDate: moment(this.filter.end_date, 'DD-MM-YYYY'),
    };

    this.getPaymentRevenue();
  }

  onChangeDate(e: any) {
    if (!e || !e.startDate || !e.endDate) return;

    const startStr = e.startDate.format('DD-MM-YYYY');
    const endStr = e.endDate.format('DD-MM-YYYY');

    this.selected = {
      startDate: moment(startStr, 'DD-MM-YYYY'),
      endDate: moment(endStr, 'DD-MM-YYYY'),
    };

    this.filter.start_date = startStr;
    this.filter.end_date = endStr;

    this.filterResult.emit(this.filter);
    this.getPaymentRevenue();
  }

  getPaymentRevenue() {
    this.loading = true;
    this.baseService.getData(PAYMENT_REVENUE, this.filter).subscribe(
      (res: {data: {total_revenue: number, total_transaction: number}}) => {
        this.cardsPayment[0].value = res.data.total_revenue;
        this.cardsPayment[1].value = res.data.total_transaction;
      },
      (error) => {
        this.message.error(error.error.meta.message);
      },
      () => {
        this.loading = false;
      }
    );
  }
}
